module.exports = __webpack_public_path__ + "media/images/emails/logo-edone-marrone-1d84afa7e7fce12a80ccecb6ef9ce9b2.png";